<template>
  <div
    class="d-flex flex-column align-center justify-center"
  >
    <v-card
      class="pa-5"
      style="max-width: 500px; width: 100%;"
    >
      <div
        v-if="item && item.amount > 0 && paymentLoaded"
        class="mb-5 d-flex flex-column align-center"
      >
        <h2
          class="mb-3"
        >{{ item.name }} Payment</h2>

        <div
          v-if="$route.query.type === 'rentals' || $route.query.type === 'single-rental'"
          class="mb-3"
        >
          <h4 v-if="property && property.line1">{{ property.line1 }}<span v-if="property.line2">{{ property.line2 }}</span></h4>
          <h4 v-if="item && item.check_in && item.check_out">{{ convertDate(item.check_in) }} - {{ convertDate(item.check_out) }}</h4>
        </div>

        <div
          v-else-if="$route.query.type === 'violation'"
        >
          <h4>Topic: {{ item.topic }}</h4>
          <h4>Description: {{ item.description }}</h4>
        </div>

        <h4
          class="mb-3"
        >Payment Due Date - {{ convertDate(item.due_date) }}</h4>

        <table
          cellspacing="0"
          style="width: 90%"
        >
          <thead>
            <tr>
              <th>Item</th>
              <th>Rate</th>
              <th>Amount</th>
              <th>Sum</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Original Payment</td>
              <td></td>
              <td></td>
              <td
                v-if="item.interest > 1"
              >${{ (item.base).toFixed(2) }}</td>
              <td
                v-else
              >${{ (item.subtotal).toFixed(2) }}</td>
            </tr>

            <tr
              v-if="item.interest > 1"
            >
              <td>Interest</td>
              <td>{{ ((item.interest - 1) * 100).toFixed(2) }}%</td>
              <td>${{ (item.subtotal - item.base).toFixed(2) }}</td>
              <td>${{ (item.subtotal).toFixed(2) }}</td>
            </tr>
            <tr
              v-if="parseFloat(globals.processing_fee) !== 0 || parseFloat(globals.processing_fee_fixed) !== 0"
            >
              <td>Processing Fee</td>
              <td>
                <span v-if="parseFloat(globals.processing_fee) !== 0">{{ globals.processing_fee }}%</span>
                <span v-if="parseFloat(globals.processing_fee) !== 0 && parseFloat(globals.processing_fee_fixed) !== 0"> + </span>
                <span v-if="parseFloat(globals.processing_fee_fixed) !== 0">${{ parseFloat(globals.processing_fee_fixed).toFixed(2) }}</span>
              </td>
              <td>${{ item.fee.toFixed(2) }}</td>
              <td>${{ (Math.round(this.item.amount * 100) / 100).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>

        <h2
          class="mt-3"
        >Total: <b>${{ (Math.round(this.item.amount * 100) / 100).toFixed(2) }}</b></h2>
      </div>

      <div
        v-else-if="Object.keys(item).length > 0 && paymentLoaded"
        class="d-flex flex-column align-center"
      >
        <h3>This payment is $0</h3>
        <br>
        <v-btn
          color="accent"
          large
          class="mx-auto"
          style="min-width: 150px;"
          @click="$router.back()"
        >
          <v-icon
            class="mr-1"
          >mdi-arrow-left</v-icon>
          <span>Back</span>
        </v-btn>
      </div>

      <div
        v-else-if="Object.keys(item).length === 0 && paymentLoaded"
        class="d-flex flex-column align-center"
      >
        <h3>This payment has been made or does not exist.</h3>
        <br>
        <v-btn
          color="accent"
          large
          class="mx-auto"
          style="min-width: 150px;"
          @click="$router.back()"
        >
          <v-icon
            class="mr-1"
          >mdi-arrow-left</v-icon>
          <span>Back</span>
        </v-btn>
      </div>

      <div
        id="paypal-button-container"
        :style="'max-width: 500px; width: 100%; z-index: 0; ' + (paypalInitialized ? 'opacity: 1;' : 'opacity: 0;')"
      ></div>
    </v-card>

  </div>
</template>

<script>
/* IMPORTS */
import { loadScript } from '@paypal/paypal-js';
import fetchV2 from '../../../assets/js/fetchV2';

export default {
  name: 'Payment',

  components: {

  },

  props: {
    permissions: {
      type: Number,
      required: true,
    },

    properties: {
      type: Array,
      required: true,
    },

    globals: {
      type: Object,
      required: true,
    }
  },

  data: () => ({
    item: {},
    paymentLoaded: false,
    paypalInitialized: false,
    property: {},
  }),

  methods: {
    convertDate(d) {
      const d2 = new Date();
      d2.setFullYear(parseInt(d.slice(0, 4)), parseInt(d.slice(5, 7)) - 1, parseInt(d.slice(8, 10)));
      d2.setHours(0, 0, 0);
      return d2.toDateString().slice(4);
    },

    getPayment(paypal) {
      return new Promise((resolve, reject) => {
        this.$emit('loading', 'Fetching payment information');
        fetchV2('GET /users/payments/personal?type=' + this.$route.query.type + '&id=' + this.$route.query.id + '&property_id=' + this.$route.query.property_id).then(payment => {
          this.item = payment;
          this.paymentLoaded = true;
          this.property = this.properties.find(p => p.id === payment.property_id) || {};
          const vue = this;

          if (payment.amount > 0) {
            this.$emit('loading', 'Initializing PayPal');
            paypal.Buttons({
              style: {
                layout: 'vertical',
                color: 'gold',
                shape: 'rect',
                label: 'pay',
                height: 40,
              },

              onInit(data, actions) {
                vue.init(data, actions);
              },

              createOrder(data, actions) {
                return vue.order(data, actions);
              },

              onApprove(data, actions) {
                return vue.approve(data, actions);
              },

              onError(err) {
                vue.error(err);
              },

              onCancel(data) {
                vue.cancel(data);
              }
            })
            .render('#paypal-button-container')
          }

          return resolve();

        }).catch(err => {
          if (err && typeof err === 'string') {
            return reject(err);
          }
          else if (err && err.message) {
            return reject(err.message);
          }
          else if (err && err.error) {
            return reject(err.error);
          }
          else {
            return reject('There was an error getting your payment information. Please retry later.');
          }
        })
      })
    },

    init(data, actions) {
      this.paypalInitialized = true;
    },

    order(data, actions) {
      return actions.order.create({
        purchase_units: [{
          amount: {
            currency_code: 'USD',
            value: (Math.round(this.item.amount * 100) / 100).toFixed(2),
          },
        }],
        // application_context: {
        //   shipping_preference: 'NO_SHIPPING',
        // },
      })
    },

    approve(data, actions) {
      this.$emit('loading', 'Capturing payment');
      return actions.order.capture().then(orderData => {
        orderData.create_time = new Date(orderData.create_time).toISOString();
        orderData.type = this.$route.query.type;
        orderData.typeID = this.$route.query.id;
        orderData.property_id = this.$route.query.property_id;
        orderData.paypal_confirm = orderData.id;

        this.$emit('loading', 'Sending payment');
        fetchV2('POST /users/payments', orderData).then((data) => {
          this.$emit('success', {
            message: 'Thank you. Your payment has been received.',
            postCall: ['refresh-payments', 'refresh-alerts'],
            postPage: `/dashboard/${this.$route.path.match(/member|manager/i)[0]}/payments`
          });
        }).catch(err => {
          this.$emit('error', {
            message: 'Your payment has been processed, but we had issues communicating with our database. Please contact ' + process.env.VUE_APP_SUPPORT_EMAIL + ' with this information ID: ' + orderData.id + ' to resolve the issue. NOTE: Your payment has been paid even though the alert shows up.',
            postCall: ['refresh-payments', 'refresh-alerts'],
            postPage: `/dashboard/${this.$route.path.match(/member|manager/i)[0]}/my-account`
          });
        })
      })
    },

    error(err) {
      if (err && typeof err === 'string') {
        this.$emit('error', 'There was an error capturing your payment. ' + err);
      }
      else if (err && typeof err === 'object') {
        this.$emit('error', 'There was an error capturing your payment. ' + JSON.stringify(err, null, 2));
      }
      else {
        this.$emit('error', 'There was an error capturing your payment.');
      }
    },

    cancel(data) {
      this.$emit('info', 'Your payment has been canceled.');
    }
  },

  mounted() {
    this.item = {};
    this.paymentLoaded = false;
    this.paypalInitialized = false;
    this.$emit('loading', 'Initializing PayPal');
    loadScript({
      clientId: process.env.VUE_APP_PAYPAL_CLIENT_ID,
      components: ["buttons", "messages"],
      dataPageType: 'checkout',
      currency: 'USD',
    }).then(paypal => {
      this.$emit('loading', 'Payment information');
      this.getPayment(paypal).then(() => {
        this.$emit('loading', false);
      }).catch(err => {
        this.$emit('error', 'There was an error initializing PayPal.' + (err ? ' ' + err : ''));
      })
    }).catch(err => {
      this.$emit('error', 'It looks like something is blocking PayPal from loading on this site. Please disable any browser extensions that may be blocking this.')
    })
  }
}
</script>

<style scoped>
th, td {
  padding: 4px 6px;
}

th {
  border-bottom: 1px solid black !important;
}

th:nth-child(1) {
  text-align: left;
}

td:nth-child(2), td:nth-child(3), td:nth-child(4) {
  text-align: center;
}

.paypal-button, .paypal-button-shape-rect {
  border-radius: 0px !important;
}
</style>
